import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})

export class FormDataService {

  constructor() { }

  createFormData(object: Object, form?: FormData, namespace?: string): FormData {

    const formData = form || new FormData();

    for (const property in object) {

      if (!object.hasOwnProperty(property) || !object[property] || object[property] === undefined) {
        continue;
      }

      const formKey = namespace ? `${namespace}.${property}` : property;

      if (object[property] instanceof Date) {
        formData.append(formKey, object[property].toISOString());
      }
      else if (Array.isArray(object[property])) {

        object[property].forEach((element, index) => {

          const tempFormKey = `${formKey}[${index}]`;

          if (typeof element === 'object' && !(element instanceof File)) {
            this.createFormData(element, formData, tempFormKey);
          }
          else {
            formData.append(tempFormKey, element);
          }
        });
      }
      else if (typeof object[property] === 'object' && !(object[property] instanceof File)) {
        this.createFormData(object[property], formData, formKey);
      }
      else {
        formData.append(formKey, object[property]);
      }
    }

    return formData;
  }
}
